import validatePassword from './js/validate-password';
import apiServer from './js/api-server';

console.log(validatePassword);

console.log(validatePassword('oiuiouhuhuh'));

console.log(apiServer["updateUserById"]);
console.log(apiServer.fetchAllUsers);
